/* src/app/components/controls/sem-messenger/sem-messenger.component.css */
.msg-body {
  white-space: pre-wrap;
  word-break: break-word;
  overflow-wrap: anywhere;
}
.msg-body a {
  text-decoration: underline;
}
/*# sourceMappingURL=sem-messenger.component.css.map */
